var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgAdvanced10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_42",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#FFA9D0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_42)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480.606 63.1739C544.511 59.902 564.912 104.122 665.725 85.7497C746.112 71.1018 780.719 125.792 790.73 159.769C795.507 176.002 796.721 239.451 752.609 240.357C602.906 243.478 482.957 407.926 410.785 264.116C381.512 205.776 335.529 70.6236 480.606 63.1739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M-141.394 -87.8261C-77.4885 -91.098 -57.0883 -46.8776 43.7247 -65.2503C124.112 -79.8982 158.719 -25.2079 168.73 8.76903C173.507 25.0025 174.721 88.4512 130.609 89.3573C-19.0939 92.4781 -139.043 256.926 -211.215 113.116C-240.488 54.7763 -286.471 -80.3764 -141.394 -87.8261Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAdvanced10);
export default __webpack_public_path__ + "static/media/bg-advanced10.dc1df99eee7f08044f2029a0f4eff442.svg";
export { ForwardRef as ReactComponent };